
import { RowDetail } from '@/main/store/@types/list.d';
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../api';
import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { listMutations } from './types';

const filter = {
	UzivatelPracovnikId: null,
	Text: null,
	Jmeno: null,
	EMailAddress: null,
	Obec: null,
	Ulice: null,
	PscNr: null,
	IcoNr: null,
	TelefonNr: null,
	ZakaznikSk: null,
	ApprovalStatus: null,
	SplatnostInlOd: null,
	SplatnostInlDo: null,
	PrevodMaxOd: null,
	PrevodMaxDo: null,
	PlatbaPzn: null,
	JinyplatceId: null,
	PrevodNoLimitPrp: null,
	NeplaticPrp: null,
	LeasfmaPrp: null,
	PojistovnaPrp: null,
	ZpracovosdatIdList: null,
	KategOzn: null,
	VstupDatOd: null,
	VstupDatDo: null,
	NarozeniDatOd: null,
	NarozeniDatDo: null,
	ServisPosledniDatOd: null,
	ServisPosledniDatDo: null,
	NvProdejDatOd: null,
	NvProdejDatDo: null,
	ProdejceNvPrp: null,
	PocetVozidelOd: null,
	PocetVozidelDo: null,
	ObratObdobiOd: null,
	ObratObdobiDo: null,
	ObratVyrobekvozOzn: null,
	ObratNdOd: null,
	ObratNdDo: null,
	ObratPpOd: null,
	ObratPpDo: null,
	ObratApujOd: null,
	ObratApujDo: null,
	ObratCelkOd: null,
	ObratCelkDo: null,
	ZakazekPocOd: null,
	ZakazekPocDo: null,
	ZakazekPocDeltaPlusOd: null,
	ZakazekPocDeltaPlusDo: null,
	ZakazekPocDeltaMinusOd: null,
	ZakazekPocDeltaMinusDo: null,
	VyrobekvozOzn: null,
	JinyplatceIdText: null,
	VariaList: [],
	SouhlasPlatnost: null as string | null,
	PlatnySouhlas: null as boolean | null,
	IsApprovalRole: null as boolean | null,
	SearchString: '',
	VIN: '',
	LicensePlate: '',
};

export class PartnerRowDetail implements RowDetail {
	loadingCount: number = 0;
	Partner = {
		ZakaznikId: null,
		Jmeno: null,
		Text: null,
		TextJmeno: null,
		Adresa: null,
		TelefonNr: null,
		IcoNr: null,
		EMailAddress: null,
	};

	RelatedData = {
		VozidloPoc: null,
		ZakazkaOtevrenaPoc: null,
		ZakazkaVsechnyPoc: null,
		SmNabidkaPoc: null,
		PneusetNaSkladePoc: null,
		ZapujckaOtevrenaPoc: null,
		ProdejNvUzavrenyPoc: null,
		NabidkaNvPoc: null,
		ProdejOvUzavrenyPoc: null,
	};
}

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ZakaznikSk: [],
		PlatbaPzn: [],
		KategOzn: [],
		ZpracovosdatId: [],
		VyrobekvozOzn: [],
		ObratVyrobekvozOzn: [],
		ZVaria: [],
		ApprovalStatus: [],
	},
	filter,
	tableSetting: {},
	rowDetail: new PartnerRowDetail(),
	localState: {},
	extraActions: {},
	extraMutations: {
		[listMutations.PARTNER_JINY_PLATCE_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.JinyplatceId = data.value;
			state.filter.JinyplatceIdText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
